<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<section class="city__office">
    <div class="city__office__container container py-4 px-0 px-md-4 px-lg-8">
        <div
            class="city__office__container__content d-flex flex-column align-items-center pb-3"
        >
            <h2 class="py-2">
                {{
                    'fe_destinations_show_city_office_details_title' | translate
                }}
            </h2>
            <div
                ngbAccordion
                class="city__office__container__content__accordion1 container mb-2"
            >
                <div
                    ngbAccordionItem
                    [collapsed]="ssr.isPlatformBrowser()"
                    #accItem="ngbAccordionItem"
                    class="city__office__container__content__office__accordion1__item"
                >
                    <div
                        ngbAccordionToggle
                        (click)="toggleContainer(0)"
                        class="city__office__container__content__office__accordion1__item__toggle d-flex flex-row justify-content-between align-items-center py-3 px-4"
                        [ngClass]="{ active: accordionVisibility[0] }"
                    >
                        <div class="d-flex">
                            <img
                                [src]="
                                    accordionVisibility[0]
                                        ? ('images/map_pin.svg' | cdn)
                                        : ('images/map-pin-white.svg' | cdn)
                                "
                                alt="Map pin"
                            />
                            <h2 class="ms-3 mb-0 align-self-center">
                                {{
                                    'fe_destinations_show_city_office_details_rent_office'
                                        | translate
                                }}
                                ({{
                                    destinations?.data?.destinations?.length ??
                                        'xx'
                                }})
                            </h2>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="me-2 info-text d-none d-sm-flex">{{
                                accordionVisibility[0]
                                    ? ('fe_destinations_locations_offices_hide_button'
                                      | translate)
                                    : ('fe_destinations_locations_offices_show_button'
                                      | translate)
                            }}</span>
                            <img
                                class="info"
                                [src]="
                                    accordionVisibility[0]
                                        ? ('images/chevron-alt-down.png' | cdn)
                                        : ('images/chevron-down-amarillo.svg'
                                          | cdn)
                                "
                                alt="More info icon"
                            />
                        </div>
                    </div>
                    <div ngbAccordionCollapse class="accordion1__hidden">
                        <div
                            ngbAccordionBody
                            class="accordion1__hidden__body pb-1 px-0"
                        >
                            <ng-template>
                                <div class="container">
                                    <div class="row">
                                        <ng-container
                                            *ngFor="
                                                let group of destinations?.data
                                                    ?.destinations ?? []
                                                    | chunk: 3
                                            "
                                        >
                                            <div
                                                class="col-12 col-md-6 col-lg-4 mb-3"
                                                *ngFor="
                                                    let destination of group
                                                "
                                            >
                                                <div
                                                    class="d-flex align-items-center"
                                                >
                                                    <img
                                                        [src]="
                                                            (destination.isAirport ===
                                                            1
                                                                ? 'images/airport_check.svg'
                                                                : 'images/city_check.svg'
                                                            ) | cdn
                                                        "
                                                        alt="Office Icon"
                                                        class="me-2 ps-4"
                                                    />
                                                    <a
                                                        [routerLink]="
                                                            ('destination-airport'
                                                                | formatUrl) +
                                                            '/' +
                                                            destination.id
                                                        "
                                                        >{{
                                                            destination.branchName
                                                        }}</a
                                                    >
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            <div
                ngbAccordion
                class="city__office__container__content__accordion1 container"
            >
                <div
                    ngbAccordionItem
                    [collapsed]="ssr.isPlatformBrowser()"
                    #accItem="ngbAccordionItem"
                    class="city__office__container__content__office__accordion1__item"
                >
                    <div
                        ngbAccordionToggle
                        (click)="toggleContainer(1)"
                        class="city__office__container__content__office__accordion1__item__toggle d-flex flex-row justify-content-between align-items-center py-3 px-4"
                        [ngClass]="{ active: accordionVisibility[1] }"
                    >
                        <div class="d-flex">
                            <img
                                [src]="
                                    accordionVisibility[1]
                                        ? ('images/map_pin.svg' | cdn)
                                        : ('images/map-pin-white.svg' | cdn)
                                "
                                alt="Map pin"
                            />
                            <h2 class="ms-3 mb-0 align-self-center">
                                {{
                                    'fe_destinations_show_city_office_details_rent_city'
                                        | translate
                                }}
                                ({{ cities?.data?.cities?.length ?? 'xx' }})
                            </h2>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="me-2 info-text d-none d-sm-flex">{{
                                accordionVisibility[1]
                                    ? ('fe_destinations_locations_offices_hide_button'
                                      | translate)
                                    : ('fe_destinations_locations_offices_show_button'
                                      | translate)
                            }}</span>
                            <img
                                class="info"
                                [src]="
                                    accordionVisibility[1]
                                        ? ('images/chevron-alt-down.png' | cdn)
                                        : ('images/chevron-down-amarillo.svg'
                                          | cdn)
                                "
                                alt="More info icon"
                            />
                        </div>
                    </div>
                    <div ngbAccordionCollapse class="accordion1__hidden">
                        <div
                            ngbAccordionBody
                            class="accordion1__hidden__body pb-1 px-0"
                        >
                            <ng-template>
                                <div class="container">
                                    <div class="row">
                                        <div
                                            class="col-12 col-md-6 col-lg-4 d-none d-lg-block"
                                        >
                                            <ng-container
                                                *ngFor="
                                                    let city of citiesGroup1
                                                "
                                            >
                                                <div
                                                    class="d-flex align-items-center"
                                                >
                                                    <a
                                                        class="px-4 pb-3"
                                                        [routerLink]="
                                                            getFormattedUrl(
                                                                city.id
                                                            ) | formatUrl
                                                        "
                                                    >
                                                        {{ city.name }} >
                                                    </a>
                                                </div>
                                            </ng-container>
                                        </div>

                                        <div
                                            class="col-12 col-md-6 col-lg-4 d-none d-lg-block"
                                        >
                                            <ng-container
                                                *ngFor="
                                                    let city of citiesGroup2
                                                "
                                            >
                                                <div
                                                    class="d-flex align-items-center"
                                                >
                                                    <a
                                                        class="px-4 pb-3"
                                                        [routerLink]="
                                                            getFormattedUrl(
                                                                city.id
                                                            ) | formatUrl
                                                        "
                                                    >
                                                        {{ city.name }} >
                                                    </a>
                                                </div>
                                            </ng-container>
                                        </div>

                                        <div
                                            class="col-12 col-lg-4 d-none d-lg-block"
                                        >
                                            <ng-container
                                                *ngFor="
                                                    let city of citiesGroup3
                                                "
                                            >
                                                <div
                                                    class="d-flex align-items-center"
                                                >
                                                    <a
                                                        class="px-4 pb-3"
                                                        [routerLink]="
                                                            getFormattedUrl(
                                                                city.id
                                                            ) | formatUrl
                                                        "
                                                    >
                                                        {{ city.name }} >
                                                    </a>
                                                </div>
                                            </ng-container>
                                        </div>

                                        <div
                                            class="col-12 col-md-6 d-md-block d-lg-none"
                                        >
                                            <ng-container
                                                *ngFor="
                                                    let city of citiesGroup4
                                                "
                                            >
                                                <div
                                                    class="d-flex align-items-center"
                                                >
                                                    <a
                                                        class="px-4 pb-3"
                                                        [routerLink]="
                                                            getFormattedUrl(
                                                                city.id
                                                            ) | formatUrl
                                                        "
                                                    >
                                                        {{ city.name }} >
                                                    </a>
                                                </div>
                                            </ng-container>
                                        </div>

                                        <div
                                            class="col-12 col-md-6 d-md-block d-lg-none"
                                        >
                                            <ng-container
                                                *ngFor="
                                                    let city of citiesGroup5
                                                "
                                            >
                                                <div
                                                    class="d-flex align-items-center"
                                                >
                                                    <a
                                                        class="px-4 pb-3"
                                                        [routerLink]="
                                                            getFormattedUrl(
                                                                city.id
                                                            ) | formatUrl
                                                        "
                                                    >
                                                        {{ city.name }} >
                                                    </a>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
